import Vue from 'vue';
import {
  mapGetters,
} from 'vuex';

import DatePicker from 'vue2-datepicker';
import Multiselect from 'vue-multiselect';
import projectDeadline from '@/components/helpers/projectDeadline/index.vue';

import jobHeaderEdit from '@/components/job/detail/jobHeaderEdit/index.vue';
import jobDetailUser from '@/components/job/detail/jobUser/index.vue';
import jobHistory from '@/components/job/detail/jobHistory/index.vue';
import jobComment from '@/components/job/detail/jobComment/index.vue';
import jobExecutors from '@/components/job/detail/jobExecutors/index.vue';

import jobPanePreparationOpen from '@/components/job/detail/jobPane/jobPanePreparationOpen/index.vue';
import jobPaneEvaluationAccepted from '@/components/job/detail/jobPane/jobPaneEvaluationAccepted/index.vue';
import jobPaneEvaluationReady from '@/components/job/detail/jobPane/jobPaneEvaluationReady/index.vue';
import jobPaneValidationAccepted from '@/components/job/detail/jobPane/jobPaneValidationAccepted/index.vue';
import jobPaneValidationReady from '@/components/job/detail/jobPane/jobPaneValidationReady/index.vue';
import jobPaneValidationOpen from '@/components/job/detail/jobPane/jobPaneValidationOpen/index.vue';
import jobPaneCompleteReady from '@/components/job/detail/jobPane/jobPaneCompleteReady/index.vue';

import {
  default as jobProjectRedirect,
  default as jobTaskRedirect,
} from '@/components/job/detail/jobRedirect/index.vue';

import buttonLoader from '@/components/button';
import preloader from '@/components/preloader/index.vue';
import rating from '@/components/rating';

import Api from '@/utils/api';

import helpers from '@/mixins/helpers';

import {
  ROLE_SYSTEM_ADMIN,
  ROLE_PROOF_READER,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  JOB_STATUS_VALIDATION,
} from '@/utils/const';

export default Vue.extend({
  mixins: [
    helpers.general,
  ],
  components: {
    jobHeaderEdit,
    jobDetailUser,
    jobHistory,
    jobComment,
    jobExecutors,
    jobPanePreparationOpen,
    jobPaneEvaluationAccepted,
    jobPaneEvaluationReady,
    jobPaneValidationAccepted,
    jobPaneValidationReady,
    jobPaneValidationOpen,
    jobPaneCompleteReady,
    jobProjectRedirect,
    jobTaskRedirect,
    buttonLoader,
    DatePicker,
    Multiselect,
    projectDeadline,
    preloader,
    rating,
    'tabs-slots': () => import('@/components/tabsSlots/index.vue'),
    'job-attachments': () => import('@/components/job/detail/jobAttachments/index.vue'),
  },
  data() {
    return {
      jobId: this.$route.params.id,
      jobData: {},
      taskData: {},
      reportData: {},

      isEdit: false,

      accountTypes: [],
      attachedFiles: [],

      editData: {
        Name: null,
        DatetimeEnd: null,
        JobDescription: null,
      },

      showExecutors: false,

      isAccept: true,
      hoverFormFile: false,

      jobAccepted: true,
      message: '',
      jobType: '',
      pending: true,
      resolveJobComment: '',
      upload: false,
      uploaded: false,
      uploadedFile: null,

      updateComment: 0,
      hoverFileUpload: false,
    };
  },
  computed: {
    userDescriptionType() {
      if (this.userRole === ROLE_PROOF_READER || this.userRole === ROLE_QA_EXPERT) {
        return 'Manager';
      }
      if (this.userRole === ROLE_PROJECT_MNG) {
        if (this.jobData.ExecutorData) {
          if (this.jobData.JobTypeData.JobTypeName === JOB_STATUS_VALIDATION) {
            return 'Qa expert';
          }
          return 'Proofreader';
        }
      }
      return '';
    },
    userDescriptionData() {
      if (this.userRole === ROLE_PROOF_READER ||
        this.userRole === ROLE_QA_EXPERT) {
        if (this.jobData.ManagerData) {
          return this.jobData.ManagerData;
        }
      }

      if (this.userRole === ROLE_PROJECT_MNG) {
        if (this.jobData.ExecutorData) {
          return this.jobData.ExecutorData;
        }
      }

      return {};
    },
    controlView() {
      var role = this.$store.getters.userRole;
      if (this.UserIsManager || role == ROLE_SYSTEM_ADMIN) {
        return 'PMInterface';
      } else if (role == ROLE_PROOF_READER && this.jobData.Executor) {
        return 'proofreaderInterface';
      } else if (role == ROLE_QA_EXPERT && this.jobData.Executor) {
        return 'QAInterface';
      } else if (role == ROLE_PROOF_READER) {
        return 'assignJobState';
      } else if (role == ROLE_QA_EXPERT) {
        return 'assignJobStateQA';
      } else {
        return 'emptyView';
      }
    },
    validationStatus() {
      return this.jobData.StatusData.Name == 'Accepted' ? 'Validation is in progress'
        : (this.jobData.StatusData.Name == 'Ready' ? 'Validation is completed' : '');
    },
    ...mapGetters({
      user: 'user',
      userRole: 'userRole',
    }),
    jobPaneComponent() {
      if (this.userRole !== ROLE_PROJECT_MNG && this.userRole !== ROLE_SYSTEM_ADMIN) {
        return false;
      }

      if (!this.jobData.JobState) {
        return false;
      }

      let nameComponent = 'job-pane-';

      nameComponent += `${this.jobData.JobTypeData.JobTypeName.toLowerCase()}-${this.jobData.JobTypeData.JobStatusName.toLowerCase()}`;
      return nameComponent;
    },
    jobPane() {
      const output = {
        job: this.jobData,
        showExecutors: this.showExecutors,
        reportData: this.reportData,
      };
      if (this.jobData.ExecutorData) {
        output.executorData = {
          firstName: this.jobData.ExecutorData.FirstName || '',
          lastName: this.jobData.ExecutorData.LastName || '',
          userId: this.jobData.ExecutorData.UserId || '',
        };
      }
      return output;
    },
    isClosed() {
      return !this.jobData.JobState ? 'job-detail--closed' : '';
    },
    jobFileUpload() {
      return this.checkPermissions('job', 'job-file-upload');
    },
    jobFileDownload() {
      return this.checkPermissions('job', 'job-file-download');
    },
    jobProjectRedirect() {
      return this.checkPermissions('job', 'job-project-redirect');
    },
    jobTaskRedirect() {
      return this.checkPermissions('job', 'job-task-redirect');
    },
  },
  created() {
    this.$store.dispatch('SHOW_PRELOADER', true);
    Promise.all([
      this.getAccountTypes(),
      this.getJobDetails(),
    ]).finally(() => {
      this.$store.dispatch('SHOW_PRELOADER', false);
    });
  },
  methods: {
    /**
     * Get account types
     */
    getAccountTypes() {
      return this.$store.dispatch('GET_ACCOUNT_TYPES').then((data) => {
        this.accountTypes = data;
      });
    },

    /**
     * Download fils (package project)
     */
    downloadPackages() {
      Api.tasks
        .getFilePackage(this.taskData.ID)
        .then((response) => {
          if (response.data.Status) {
            this.donwloadFileOnLink(response.data.Data, 'Taskfiles.zip');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Get information from job
     */
    getJobDetails() {
      return Api.jobs
        .jobsDetail(this.jobId)
        .then((response) => {
          if (response.data.Status) {
            this.jobData = response.data.Data;
            this.setExecutorsData();
            this.getTaskDetails();
            this.setEditData();
            this.controlStatus();
          }
        });
    },

    /**
     * Set executor data for different job-pane components
     */
    setExecutorsData() {
      this.jobData.proofreaderJson = this.jobData.ProofReader
        ? JSON.parse(this.jobData.ProofReader)[0] : this.jobData.ExecutorData;
    },

    /**
     * Set default data for edit job
     */
    setEditData() {
      this.editData = {
        Name: this.jobData.Name,
        DatetimeEnd: this.jobData.DatetimeEnd * 1000,
        JobDescription: this.jobData.GenDescription,
      };
    },

    /**
     * Method for set different status
     *
     * TODO: rewrite this method
     */
    controlStatus() {
      var status = this.jobData.StatusData.Name;
      if (status == 'Open') {
        this.jobType = 'openJob';
      }
      if (this.jobData.executorData == null) {
        this.jobType = 'openJob';
        return false;
      }

      var userType = this.jobData.ExecutorData.AccountTypeID;
      if (userType == 3 && status == 'Accepted') {
        this.jobType = 'assignByPR';
      } else if (userType == 4 && status == 'Accepted') {
        this.jobType = 'assignByQA';
      } else if (userType == 3 && status == 'Ready') {
        this.jobType = 'assignByPR';
      } else if (userType == 4 && status == 'Ready') {
        this.jobType = 'assignByQA';
      } else {
        this.jobType = '';
      }
    },

    /**
     * Edit job
     */
    editJob() {
      const params = {
        ID: this.jobData.ID,
        Name: this.editData.Name || this.jobData.Name,
        DatetimeEnd: this.editData.DatetimeEnd / 1000,
        JobDescription: this.editData.JobDescription || this.jobData.GenDescription,
      };

      Api.jobs
        .updateJob(params)
        .then((response) => {
          if (response.data.Status) {
            const data = response.data.Data;

            this.isEdit = false;
            this.jobData.Description = data.JobDescription;
            this.jobData.Name = data.Name;
            this.jobData.DatetimeEnd = data.DatetimeEnd;

            this.$root.$emit('notification', {
              message: 'The job’ve been updated',
              type: 'info',
              show: true,
            });

            this.setEditData();
            this.getJobDetails();
          } else {
            this.$root.$emit('notification', {
              message: 'The job’ve been rejected',
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Add file to array
     */
    addFile(e) {
      const fileInput = document.getElementById('dragdrop');
      const file = fileInput.files[0];
      this.checkFileReportFormat(file);
    },

    /**
     * Method for hendler dragdrop event file
     *
     * @param {Event} e
     */
    addFileDrag(e) {
      const file = e.dataTransfer.files[0];
      this.checkFileReportFormat(file);
      this.hoverFormFile = false;
    },

    /**
     * Check file format
     */
    checkFileReportFormat(file) {
      if (file.type === 'text/xml') {
        this.uploadedFile = file;
      } else {
        this.$root.$emit('notification', {
          message: 'Not valid format.<br>Only xml',
          type: 'error',
          show: true,
        });
      }
    },

    /**
     * Accept job
     */
    acceptJob() {
      if (!this.isAccept) return;

      const params = {
        jobID: this.jobData.ID,
        userToken: this.$store.getters.token,
      };

      Api.jobs
        .accept(params)
        .then((response) => {
          if (response.data.Status) {
            this.pending = false;
            this.message = 'Successfully accepted';

            this.$root.$emit('notification', {
              message: 'The job’ve been accepted.',
              type: 'info',
              show: true,
            });

            this.getJobDetails();
          } else {
            this.$root.$emit('notification', {
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Report deadlinte pane
     *
     * @param {Unix} deadline
     * @param {Unix} end
     */
    reportDate(deadline, end) {
      var delta = deadline - end;
      if (delta < 0) {
        return 'alert';
      } else if (delta < 60480) {
        return 'warning';
      } else {
        return 'normal';
      }
    },

    /**
     * Reject job
     */
    rejectJob() {
      Api.jobs
        .rejectJob(this.jobData.ID)
        .then((response) => {
          if (response.data.Status) {
            this.pending = false;
            this.message = 'The job’ve been rejected';
            this.jobAccepted = false;

            this.$root.$emit('notification', {
              message: 'The job’ve been rejected',
              type: 'info',
              show: true,
            });

            setTimeout(() => {
              this.$router.push({
                name: 'jobs',
                params: {
                  view: 'tile',
                },
              });
            }, 1500);
          } else {
            this.$root.$emit('notification', {
              message: response.Data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Get task detail
     */
    getTaskDetails() {
      Api.jobs
        .getTaskInJobDetail(this.jobData.TaskID)
        .then((response) => {
          if (response.data.Status) {
            this.taskData = response.data.Data;
            this.getReportsByTaskID();
          }
        });
    },

    /**
     * Get reports by task id
     */
    getReportsByTaskID() {
      Api.jobs
        .getReportByTaskID(this.taskData.ID)
        .then((response) => {
          if (response.data.Status) {
            this.reportData = response.data.Data;
          }
        });
    },

    /**
     * Send report for job
     */
    sendReport() {
      if (this.uploadedFile) {
        this.hoverFileUpload = true;
        var reader = new FileReader();
        const readerPromise = new Promise((res) => {
          reader.onload = (event) => res({
            params: event.target.result,
            id: this.jobData.ID,
            comment: this.resolveJobComment,
          });
        });
        reader.readAsText(this.uploadedFile);
        readerPromise.then((params) => {
          Api.jobs.addReportTojob(params)
            .then((response) => {
              if (response.data.Status) {
                if (this.resolveJobComment.trim().length > 0) {
                  this.addCommentReport();
                }
                this.$root.$emit('notification', {
                  message: 'File was uploaded',
                  type: 'info',
                  show: true,
                });
                return this.getJobDetails();
              } else {
                this.$root.$emit('notification', {
                  message: response.data.Message,
                  type: 'error',
                  show: true,
                });
              }
            }).finally(() => {
              this.hoverFileUpload = false;
              this.uploadedFile = null;
            });
        });
      };
    },

    /**
     * Add comment to report for job
     */
    addCommentReport() {
      const params = {
        authorID: this.user.UserId,
        innerText: this.resolveJobComment,
        jobID: this.jobData.ID,
      };

      Api.jobs
        .addCommentReportToJob(params)
        .then((response) => {
          if (response.data.Status) {
            this.updateComment++;
            this.getJobDetails();
          }
        });
    },
  },
});
